export default {
  'memberCard.title': 'Member Card',
  'memberCard.exchangePoint': 'Redeem Points',
  'memberCard.exchange': 'Redeem',
  'memberCard.transfer': 'Transfer',
  'memberCard.stamp': 'Stamp',
  'memberCard.message.invalid':
    'Membership card functionality is not yet available. Please stay tuned.',
  'memberCard.setting_invoice_carrier': 'Set Invoice Carrier',
  'memberCard.show_invoice_carrier': 'Show Invoice Carrier',
  'memberCard.hide_invoice_carrier': 'Hide Invoice Carrier',
  'memberCard.total_consumption': 'Total Accumulated Spending',
  'memberCard.near_expired_point': 'Points Near Expiry',
  'memberCard.point': 'Points',
  'memberCard.expire': 'Expire',
  'memberCard.member_period': 'Membership Validity Period',
  'memberCard.no_limit': 'No Expiry',
  'memberCard.to': 'To',
  'memberCard.need_consumption': 'Additional Spending Needed',
  'memberCard.point_rights': 'Points Benefits',
  'memberCard.point_records': 'Points Record',
  'memberCard.choose_notice': 'Please Choose a Usage Method',
  'memberCard.add_consumption_record': 'Add Consumption Record',
  'memberCard.point.collect': 'Collect Points',
  'memberCard.add_trade_record': 'Add Transaction Record',
  'memberCard.become_brand_friend': 'Become a Brand Friend',
  'memberCard.invalid': 'Not Activated',
  'memberCard.not_open': 'Not Opened Yet',
  'memberCard.transfer_point': 'Transfer Points',
  'memberCard.transfer_to_friend': 'Transfer to Friend',
  'memberCard.transfer_success': 'Transfer Successful!',
  'memberCard.error.can_not_transfer_to_self':
    'Cannot transfer points to yourself',
  'memberCard.error.friend_not_member':
    'The friend is not a brand member, transfer failed. Please inform them to register as a member',
  'memberCard.notice.enter_friend_phone':
    'Please enter your friend’s phone number',
  'memberCard.notice.friend_log_in':
    'Your friend will be able to see the points once they log into the service',
  'memberCard.notice.will_share': 'You are about to transfer',
  'memberCard.notice.point_to': 'points to',
  'memberCard.handle_time': 'Handling Time',
  'memberCard.error.member_point.not_match':
    'This purchase does not qualify for membership points collection, so the points collection failed. The amount has been recorded in your accumulated spending.',
  'memberCard.error.MEMBER_CARD_EXTERNAL_TOKEN_FAILED':
    'Verification failed. Please scan again or try later.',
  'memberCard.error.MEMBER_CARD_EXTERNAL_BRAND_CODE_MISMATCH':
    'The brand information does not match. Please check and try again.',
  'memberCard.error.MEMBER_CARD_SYSTEM_ERROR':
    'The system cannot process this request right now. Please try later.',
  'memberCard.error.unknown':
    'Failed to add consumption record. Please try later.',
  'memberCard.change_send_point': 'Point Credit Adjustment',
  'memberCard.change_deduct_point': 'Point Deduction Adjustment',
  'memberCard.current_accumulated_point': 'Current Accumulated Points',
  'memberCard.accumulate': 'Spend',
  'memberCard.accumulated_point': 'Accumulated Points',
  'memberCard.accumulated_member_point': 'Accumulated Membership Points',
  'memberCard.point_change_fail': 'Point Adjustment Failed',
  'memberCard.trade_has_accumulated':
    'This transaction has been recorded in your accumulated spending',
  'memberCard.consumption_record_add_fail': 'Failed to add consumption record',
  'memberCard.no_member_benefit': 'No membership benefits available',
  'memberCard.your_member_level': 'Your Current Membership Level',
  'memberCard.other_member_level': 'Other Membership Levels',
  'memberCard.member_ship': 'Membership',
  'memberCard.accumulated_consumption':
    'Accumulated spending within the membership',
  'memberCard.total_accumulated_consumption': 'Total accumulated spending',
  'memberCard.price.level': 'Accumulated spending within the level',
  'memberCard.price.membership':
    'Accumulated spending within the membership period',
  'memberCard.dollar': 'Dollar(s)',
} as Record<string, string>;
